import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconLock = (props: PropsType) => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          d='M25.6386 50.2778L23.6665 48.3057L35.8886 36.0832L42.7498 42.9444L52.3332 33.389H47.3611V30.6111H56.9998V40.2498H54.2498V35.389L42.7219 46.9165L35.8611 40.0557L25.6386 50.2778Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgIconLock;
